<template>
  <div class="wrap">
    <Header :isHeaderActive="isHeaderActive" />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
export default {
  name: "MainLayout",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      lastScrollTop: 0,
      isHeaderActive: false,
    };
  },
  methods: {
    handleScroll() {
      const currentScrollTop =
        window.scrollY || document.documentElement.scrollTop;

      // 스크롤 위치에 따라 헤더 활성화 상태 업데이트
      if (currentScrollTop > this.lastScrollTop) {
        this.isHeaderActive = true; // active 클래스 추가
      } else {
        this.isHeaderActive = false; // active 클래스 제거
      }
      this.lastScrollTop = currentScrollTop; // 마지막 스크롤 위치 업데이트
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 메인 페이지일 때만 이벤트 리스너 추가
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/reset.css";
@import "@/assets/css/fonts.css";
@import "@/assets/css/common.css";
@import "@/assets/css/main.css";
</style>